import { Vertical } from '../enums';

import { RequestError } from './RequestError';

export class VerticalStatusError extends RequestError {
  constructor(vertical: Vertical, service: string, method: string) {
    super({
      service,
      method,
      body: {
        code: 'SERVICE_UNAVAILABLE',
        text: `${Vertical[vertical]} status is "red"`
      }
    });

    this.name = 'VerticalStatusError';
    this.message = `${Vertical[vertical]} status is "red"`;
  }
}
